import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import './index.sass';

const { block, el } = bem('green-text');

export const GreenText = ({color = '#22C68D', fontWeight = '400', children}) => {
    return <span className={block()} style={{color, fontWeight}}>{children}</span>
}
